import { render, staticRenderFns } from "./v-how-it-works.vue?vue&type=template&id=7274b964&"
import script from "./v-how-it-works.vue?vue&type=script&lang=js&"
export * from "./v-how-it-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports